import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight, Lock } from "lucide-react";
import { IMG } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
};

export default function AdminLogin() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const data = Object.fromEntries(new FormData(e.currentTarget));
    try {
      await axios.post(`${API}/auth/login`, data, { withCredentials: true });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="admin-login-page">
      <form className="form-card admin-login-card" onSubmit={submit} data-testid="admin-login-form">
        <img src={IMG.logo} alt="Dishan International Group" className="admin-login-logo" />
        <h3><Lock size={17} /> Team access</h3>
        <p className="admin-login-note">Private dashboard for the Dishan team.</p>
        <label>Email<input name="email" type="email" required placeholder="you@dishan.com" data-testid="admin-email-input" /></label>
        <label>Password<input name="password" type="password" required placeholder="Your password" data-testid="admin-password-input" /></label>
        {error && <p className="error-message" data-testid="admin-login-error">{error}</p>}
        <button className="btn btn-primary form-submit" type="submit" disabled={loading} data-testid="admin-login-button">
          {loading ? "Signing in…" : "Sign In"} <ArrowUpRight size={16} />
        </button>
      </form>
    </main>
  );
}
